<template>
     <modal name="search_individual_claim" no-default-button="true">
        <h1>
            Search an individual claim
        </h1>
        <p>
            Please enter claimant reference or name to search claims
        </p>
        <div class="flex-grid a-form-inputs">
            <div class="flex-grid__g-4 u-flex-grow-none">
                <input type="text">
            </div>
            <div class="flex-grid__g-2 u-flex-grow-none">
                <button class="a-button a-button--small u-no-margin">Search</button>
            </div>
        </div>
        <table class="a-table u-full-width">
            <tr>
                <th>Your Reference</th>
                <th>Claim Type</th>
                <th>Claimant Name</th>
                <th>Defendant Name</th>
                <th>Claimant Solicitor</th>
                <th>Updated At</th>
                <th></th>
            </tr>
            <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>
                    <icon-tooltip 
                        tooltip-text="load"
                        side="left"
                        text-width="100"
                        icon-type="load">
                    </icon-tooltip>
                </td>
            </tr>
        </table>
    </modal> 
</template>

<script>
    import Control from 'components/form/Control.vue';
    import IconTooltip from 'components/IconTooltip.vue';
    import Modal from 'components/modal/Modal.vue';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

    export default {
        name: 'individual-search-modal',
        components: {
            Control,
            IconTooltip,
            Modal,
        },
        computed: {
            ...mapState('discountRateComparison', {

            }),
        },
        methods: {
            ...mapActions('discountRateComparison', [
                
            ]),
        }
    }
</script>



// WEBPACK FOOTER //
// IndividualSearchModal.vue?66411783